import columns from './DayCoefficientsTableConfig';
import DayCoefficientsFormConfig from './DayCoefficientsFormConfig';
import LongerStatesDiscountsTableConfig from './LongerStatesDiscountsTableConfig';
import LongerStatesDiscountsFormConfig from './LongerStatesDiscountsFormConfig';
import DayCoefficientsTableConfig from './DayCoefficientsTableConfig';


function rateField(column, name, label) {
  return {
    name: name,
    label: label,
    type: 'number',
    defaultValue: '0',
    mandatory: true,
    column: column,
    scale: 2,
    fixedDecimalScale: true,
    suffix: 'zł',
    component: 'rates',
  };
}

export function coefficientField(component, column, name, label) {
  return {
    name: name,
    label: label,
    type: 'number',
    defaultValue: '1',
    mandatory: true,
    column: column,
    scale: 2,
    fixedDecimalScale: true,
    component: component,
  };
}

export const fields = {
  config: { columns: 1 },
  fields: [
    {
      name: 'name',
      label: 'Nazwa',
      column: 1,
      mandatory: true,
    },
    {
      name: 'active',
      label: 'Aktywny',
      column: 2,
      type: 'boolean',
      defaultValue: 'true',
      mandatory: true,
    },

    {
      name: 'rates',
      column: 1,
      title: 'Stawki/Doba',
      type: 'component',
      config: { columns: 2 },
    },
    rateField(1, 'dayRate', 'Domek'),
    {
      name: 'dayRatePersonLimit',
      label: 'Liczba osób w cenie dobowej',
      type: 'number',
      column: 2,
      scale: 0,
      nullOnEmpty: true,
      placeholder: 'Brak wartości - bez limitu',
      component: 'rates',
    },
    {
      name: 'personRates',
      column: 1,
      type: 'component',
      config: { columns: 3 },
    },
    {
      ...rateField(1, 'adultRate', 'Dorosły'),
      component: 'personRates',
    },
    {
      ...rateField(2, 'childRate', 'Dziecko 7-12'),
      component: 'personRates',
    },
    {
      ...rateField(3, 'babyRate', 'Dziecko 0-6'),
      component: 'personRates',
    },
    {
      name: 'coefficientsDay',
      column: 1,
      title: 'Dni tygodnia - Współczynniki',
      type: 'component',
      customCol: true,
      config: { columns: 7, notStandardSize: true },
    },
    coefficientField('coefficientsDay', 1, 'mondayCoefficient', 'Pn'),
    coefficientField('coefficientsDay', 2, 'tuesdayCoefficient', 'Wt'),
    coefficientField('coefficientsDay', 3, 'wednesdayCoefficient', 'Śr'),
    coefficientField('coefficientsDay', 4, 'thursdayCoefficient', 'Cz'),
    coefficientField('coefficientsDay', 5, 'fridayCoefficient', 'Pt'),
    coefficientField('coefficientsDay', 6, 'saturdayCoefficient', 'Sb'),
    coefficientField('coefficientsDay', 7, 'sundayCoefficient', 'Nd'),
    {
      name: 'dayCoefficients',
      column: 1,
      title: 'Wybrane dni - Współczynniki',
      type: 'functionalTableField',
      functionalTableConfig:{
        columns: DayCoefficientsTableConfig,
        fields:  DayCoefficientsFormConfig,
        editable: false,
        deleteModalTitle: 'Usunięcie współczynnika',
        creationTitle: 'Dodanie współczynnika',
        deleteModalDescription: 'Czy na pewno chcesz usunąć współczynnik?'
      }
    },
    {
      name: 'longerStayDiscounts',
      column: 1,
      title: 'Rabaty za dłuższy pobyt',
      type: 'functionalTableField',
      functionalTableConfig:{
        columns: LongerStatesDiscountsTableConfig,
        fields:  LongerStatesDiscountsFormConfig,
        deleteModalTitle: 'Usunięcie rabatu',
        creationTitle: 'Dodanie rabatu',
        editable: false,

        deleteModalDescription: 'Czy na pewno chcesz usunęć rabat?'
      }
    },
  ],
};
